import { useMemo } from 'react';
import { ContentTypeFieldResponse } from '../../../../Model/responseDtos/ContentTypeFieldResponse';
import { ContentTypeFieldGroupResponse } from '../../../../Model/responseDtos/ContentTypeFieldGroupResponse';

interface FieldsByGroup {
  grouped: Map<string, ContentTypeFieldResponse[]>;
  ungrouped: ContentTypeFieldResponse[];
}

interface UseFieldGroupsParams {
  fields: ContentTypeFieldResponse[];
  groups?: ContentTypeFieldGroupResponse[];
}

export const useFieldGroups = ({ fields, groups = [] }: UseFieldGroupsParams): FieldsByGroup => {
  return useMemo(() => {
    const grouped = new Map<string, ContentTypeFieldResponse[]>();
    const groupedFieldNames = new Set<string>();

    const fieldsWithoutFileDependency = fields.filter(field => !field.fileDependent);

    groups.forEach((group: ContentTypeFieldGroupResponse) => {
      const groupFields = group.fieldNames
        .map(fieldName => fieldsWithoutFileDependency.find(f => f.name === fieldName))
        .filter((field): field is ContentTypeFieldResponse => field != null);

      if (groupFields.length > 0) {
        grouped.set(group.name, groupFields);
        groupFields.forEach(field => groupedFieldNames.add(field.name));
      }
    });

    const ungrouped = fieldsWithoutFileDependency.filter(field => !groupedFieldNames.has(field.name));

    return { grouped, ungrouped };
  }, [fields, groups]);
};
